/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export type API76366Req = {};



export interface API76366Res {
  /** 待办完成红点  */
  todoFinish?: number;
  /** 待办协助红点  */
  todoJoin?: number;
  /** 待办处理红点  */
  todoWorking?: number;
  /** 创建处理红点  */
  createWorking?: number;
  /** 创建处理红点  */
  createFinish?: number;
  /** 创建处理红点  */
  createUnFinish?: number;
  
};


// 接口函数 76366 获取红点

export interface IUseGetAPI76366Return {
  /** 获取红点: 接口请求状态 */
  isAPI76366Loading: boolean;
  /** 获取红点: 接口请求返回数据 */
  dataAPI76366: API76366Res;
  /**  获取红点: 接口数据请求方法 */
  fetchAPI76366Data: ( config?: YWRequestConfig) => Promise<API76366Res>;
  /** 获取红点: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76366 = ():IUseGetAPI76366Return => {
  let isMount = true;
  const [isAPI76366Loading, setIsAPI76366Loading] = useState(false);
  const [dataAPI76366, setDataAPI76366] = useState<API76366Res>({} as API76366Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/room/red/point`;

  const fetchAPI76366Data = async ( config?: YWRequestConfig): Promise<API76366Res> => {
  
    if ( isMount ) {
      setIsAPI76366Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76366Res>(`${basePath}/yoaichat-web/chat/room/red/point`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76366(res || {} as API76366Res);
        setIsAPI76366Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76366Loading(false);
      }
      return false as unknown as API76366Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76366Loading,
    dataAPI76366,
    fetchAPI76366Data,
    requestUrl,
  }
}

